var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pixelart",attrs:{"id":"app"}},[_c('Header'),_c('Intro'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }